import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { IApplicableItemsData } from "@/api_framework/api_modals/coupon";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

// Resolves a coupon's included item ids to names (grouped by type) for the modal.
export const useCouponApplicableItemsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [items, setItems] = useState<IApplicableItemsData | null>(null);
  const [loading, setLoading] = useState(false);

  const execute = useCallback(async (couponId: string) => {
    setLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${COUPON_SERVICE_APIS?.COUPON_LIST?.baseURL}/${couponId}/applicable-items`, {
          headers: { Authorization: `${accessToken}`, "Content-Type": "application/json" },
        })
        .then((res: AxiosResponse<{ status: boolean; data: IApplicableItemsData }>) => {
          setItems(res.data?.status ? res.data.data : null);
        })
        .catch((e: AxiosError) => {
          setItems(null);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return { execute, items, loading, setItems };
};
